import React, { FunctionComponent } from 'react'
import { SVGProps } from 'interfaces'


const SVG: FunctionComponent<SVGProps> = ({ className }) => (
    <svg width='100%' className={className} viewBox='0 0 8 4' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M6.2236 0.146447C6.41886 -0.0488153 6.73544 -0.0488153 6.9307 0.146447C7.12596 0.341709 7.12596 0.658291 6.9307 0.853553L3.9307 3.85355C3.74141 4.04284 3.43662 4.04947 3.23929 3.86858L0.239287 1.11858C0.0357275 0.931981 0.0219755 0.615697 0.208572 0.412138C0.395168 0.208578 0.711452 0.194827 0.915011 0.381423L3.56211 2.80793L6.2236 0.146447Z'
            fill='#C4C4C4'
        />
    </svg>
)

export default SVG
